<template>
  <div class="signInBox">
    <div class="title">
      <div class="titleIcon" @click="goBack">
        <i class="el-icon-arrow-left"></i>
      </div>
      <h2>签到</h2>
    </div>
    <div class="signInContent">
      <div class="calendarBox">
        <!-- {{ datas }} -->
        <el-calendar 
          v-model="calendarValue" 
          :class="['calendarContent', isDark ? 'darkCalendar' : '']"
        >
          <template
            slot="dateCell"
            slot-scope="{date, data}">
            <!-- <p :class="data.isSelected ? 'is-selected' : ''">
              {{ data.day.split('-').slice(2).join('-') }} {{ data.isSelected ? '✔️' : ''}}
            </p> -->
            <div @click="handleDateClick(data)" class="dataBox">
              {{ data.day.split('-').slice(2).join('-') }}
              <div v-if="isSignIn(data)">
                ✔️
              </div>
            </div>
          </template>
        </el-calendar>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import {mapState} from 'vuex';

export default {
  name: 'SignIn',
  components: {},
  props: {},
  data () {
    return {
      calendarValue: new Date(),
      tradeData: [
        {
          date: '2024-05-20',
          isSelected: true,
        },
        {
          date: '2024-05-21',
          isSelected: false,
        },
        {
          date: '2024-05-22',
          isSelected: false,
        },
        {
          date: '2024-05-23',
          isSelected: true,
        },
      ],
    }
  },
  computed: {
    ...mapState('comAbout', ['isDark']),
    isSignIn() {
      return (data) => {
        const isSelected = this.tradeData.filter(item => item.date === data.day)[0]?.isSelected;
        
        return isSelected;
      }
    },
    nowMonth() {
      const today = new Date();
      const month = today.getMonth();
      console.log(month);
      return today;
    },
  },
  watch: {},
  created () {},
  mounted () {},
  methods: {
    // 点击日期事件
    handleDateClick(data) {
      const today = dayjs().format('YYYY-MM-DD');
      const diff = this.checkData(data.day, today);
      
      if (diff >= 0 && diff < 14) {
        console.log('签到');
        const newDates = this.tradeData.filter(item => item.date === data.day);
        if (newDates.length) {
          this.tradeData = this.tradeData.map(item => {
            if (item.date === data.day) {
              const isSelected = true;
              return { ...item, isSelected };
            }
            return { ...item };
          })
        } else {
          this.tradeData.push({
            date: data.day,
            isSelected: true,
          })
        }
      } else {
        console.log('不可签到');
        this.$message.warning('不可签到');
      }
    },
    // 判断日期间隔天数
    checkData(day, today) {
      // 创建起始日期和结束日期对象
      const startDate = dayjs(day);  
      const endDate = dayjs(today);
    
      // 计算日期差异
      const diff = endDate.diff(startDate, 'days');
      return diff;
    },
    goBack() {
      this.$emit('goBack');
    }
  }
}
</script>

<style scoped lang="less">
.signInBox {
  width: 100%;
  height: 100%;
  .title {
    line-height: 24px;
    margin: 16px 0 8px;
    height: 22px;
    display: flex;
    align-items: center;

    h2 {
      font-size: 18px;
      font-weight: 600;
    }
    .titleIcon {
      cursor: pointer;
      margin-right: 10px;
      i {
        color: #aaa;
        font-size: 24px;
      }
    }
  }
  .signInContent {
    height: calc(100% - 22px - 30px);
    flex: 1;
    overflow-y: auto;
    padding-right: 3px;
    position: relative;

    .calendarBox {
      // height: 300px;
      .calendarContent {
        // background-color: #ebeff4;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
        /deep/.el-calendar-table .el-calendar-day {
          height: 50px;
        }
        /deep/thead {
          text-align: center;
        }
        /deep/.el-calendar__header {
          background-color: #2f80ec;
          .el-calendar__title {
            color: #fff;
          }
        }
        .dataBox {
          height: 100%;
          text-align: center;
        }
      }
      .is-selected {
        color: #1989FA;
      }
      .darkCalendar {
        background-color: #293145;
        color: #ddd;
        /deep/.el-calendar__title {
          color: #ddd;
        }
        /deep/.el-calendar-table:not(.is-range) td.next, /deep/.el-calendar-table:not(.is-range) td.prev {
          color: #606266;
        }
        /deep/.el-calendar-table tr td:first-child {
          border-color: #1a2236;
        }
        /deep/.el-calendar-table tr:first-child td {
          border-color: #1a2236;
        }
        /deep/.el-calendar-table td {
          border-color: #1a2236;
        }
        /deep/.el-calendar-table .el-calendar-day:hover {
          background-color: #2f80ec;
        }
      }
    }
  }
}
</style>
